import * as AesirApi from './api/aesirApi'
import store from 'store'
import { merge } from 'lodash'
import { getClient as getChatClient } from 'services/yggdrasil/chat/chatClient'
import FileSaver, { saveAs } from 'file-saver'

export function loadFreeSubscription (formSlug) {
    return AesirApi.loadFromAesir(`subscriptions/form/${formSlug}`, false)
}

export async function LoadMenu () {
    return AesirApi.loadFromAesir(`menu`, false)
}

export function loadVideoLogForCourseAndVideo (courseId, videoId) {
    return AesirApi.loadFromAesir(`videologs/courses/${courseId}/video/${videoId}`)
}

export function loadVideoLogForMicroLearningElements (courseId) {
    return AesirApi.loadFromAesir(`videologs/courses/${courseId}`)
}

export function loadCoursesForVideolog () {
    return AesirApi.loadFromAesir(`videologs/courses`)
}

export function loadVideologs () {
    return AesirApi.loadFromAesir(`videologs/progress`)
}

export async function LoadCourses (slug) {
    return AesirApi.loadFromAesir(`packages/${slug}/courses`, false)
}

export async function LoadRecommendedCourses () {
    return AesirApi.loadFromAesir(`courses/recommended`)
}

export async function LoadFeaturedContent () {
    return AesirApi.loadFromAesir(`content-recommendations/featured`, false, applyLanguageParamToConfig())
}

export async function LoadMostPopular () {
    return AesirApi.loadFromAesir(`content-recommendations/most-popular`, false, applyLanguageParamToConfig())
}

export async function LoadMostPopularCoursesInUsersMostPopularPackage () {
    return AesirApi.loadFromAesir(`courses/most-popular/by-my-most-popular-package`, true, applyLanguageParamToConfig())
}

export async function LoadCustomerSpecificCourses () {
    return AesirApi.loadFromAesir(`content-recommendations/customer-specific`, true, applyLanguageParamToConfig())
}

export async function LoadUpcomingDigitalClassrooms () {
    return AesirApi.loadFromAesir(`digital_classroom_trainings/upcoming`, false, applyLanguageParamToConfig())
}

export async function LoadUpcomingLiveEvents () {
    return AesirApi.loadFromAesir(`live-events/upcoming`, false, applyLanguageParamToConfig())
}

export async function LoadRecentlyAddedCourses () {
    return AesirApi.loadFromAesir(`courses/recently_added`, false, applyLanguageParamToConfig())
}

export async function LoadUserInfo () {
    return AesirApi.loadFromAesir(`info`)
}

export async function LoadPackageInfo () {
    return AesirApi.loadFromAesir(`packages`, false)
}

export async function LoadCourseById (id) {
    return AesirApi.loadFromAesir(`courses/${id}`, false)
}

export async function loadCourseTestUrl (courseId) {
    return AesirApi.loadFromAesir(`certificates/courses/${courseId}/test`, false)
}

export async function LoadCollectionById (id) {
    return AesirApi.loadFromAesir(`collections/${id}`, false)
}

export async function LoadCollectionCoursesById (id) {
    return AesirApi.loadFromAesir(`collections/${id}/courses`, false)
}

export async function LoadLearningPathCoursesBySlug (slug) {
    return AesirApi.loadFromAesir(`learning-paths/slug/${slug}/courses`, false)
}

export async function loadCertificates () {
    return AesirApi.loadFromAesir(`certificates`)
}

export async function loadWatchlists () {
    return AesirApi.loadFromAesir(`watchlists`)
}

export async function loadWatchlistSubordinates () {
    return AesirApi.loadFromAesir(`subordinates`)
}

export async function loadNotes () {
    return AesirApi.loadFromAesir(`notes`)
}

export async function loadCoursesCategories () {
    return AesirApi.loadFromAesir(`categories`, false)
}

export async function loadUrlForCourseTest (courseId) {
    return AesirApi.loadFromAesir(`certificates/courses/${courseId}/test`)
}

async function loadRestrictedCourses () {
    return AesirApi.loadFromAesir(`courses/restricted`)
}

async function loadRestrictedCollection () {
    return AesirApi.loadFromAesir(`collections/restricted`)
}

export function loadJobTitles () {
    return AesirApi.loadFromAesir(`dictionaries/jobtitles`, false)
}

export function loadAgreementForm (slug) {
    return AesirApi.loadFromAesir(`agreements/${slug}`, false)
}

export function loadNotification (context) {
    return AesirApi.loadFromAesirWithoutMember(`notification/newest_by_context_type_id/${context}`)
}

export async function loadSubscribedLearningPaths () {
    return AesirApi.loadFromAesir(`learning-paths/subscribed`)
}

export async function loadUserRatings () {
    return AesirApi.loadFromAesir(`course-ratings`)
}

export function loadDigitalClassroomSubscriptions () {
    return AesirApi.loadFromAesir(`digital-classrooms/subscriptions`)
}

export function LoadDigitalClassRoomSignUpsForCourse (courseId) {
    return AesirApi.loadFromAesir(`digital-classrooms/${courseId}/trainings`)
}

export function LoadAllDigitalClassRoomEvents () {
    return AesirApi.loadFromAesir(`digital-classrooms/trainings`, false)
}

export function LoadSignedUpEventsForUser () {
    return AesirApi.loadFromAesir(`digital-classrooms/subscriptions`)
}

export function LoadSingleDigitalClassRoomEvent (eventId) {
    return AesirApi.loadFromAesir(`digital-classrooms/trainings/${eventId}`)
}

export function loadSingleLearningPathById (learningPathId) {
    return AesirApi.loadFromAesir(`learning-paths/${learningPathId}`, false)
}

export async function loadRestrictedData () {
    let [courses, collections] = await Promise.all([
        loadRestrictedCourses(),
        loadRestrictedCollection()
    ])
    return {
        courses,
        collections
    }
}

export async function search (filter, abortSignal) {
    return AesirApi.postToAesir('search', filter, false, abortSignal !== undefined ? { signal: abortSignal } : {})
}

export async function requestSSOLoginUrl (serviceId) {
    return AesirApi.loadFromAesirWithoutMember(`sso/login_page_url/${serviceId}`)
}

function applyLanguageParamToConfig (config = {}) {
    return merge(config, {
        params: {
            language: store.getters['Languages/getSelectedCountryCode']
        }
    })
}

function getReportRequestData (filter) {
    return {
        ...filter,
        language: store.getters['Languages/getSelectedCountryCode']
    }
}

export async function LoadMembersForReporting (filter) {
    return AesirApi.postToAesir(`report/members/table`, getReportRequestData(filter))
}

export async function LoadMembersDashboardForReporting (filter) {
    return AesirApi.postToAesir(`report/members/dashboard`, getReportRequestData(filter))
}

export async function LoadMemberDetailsForReporting (memberId, filter) {
    return AesirApi.postToAesir(`report/members/details/${memberId}`, getReportRequestData(filter))
}

export function LoadCoursesForReporting (filter) {
    return AesirApi.postToAesir(`report/courses/table`, getReportRequestData(filter))
}

export async function LoadCoursesDashboardForReporting (filter) {
    return AesirApi.postToAesir(`report/courses/dashboard`, getReportRequestData(filter))
}

export async function LoadCourseDetailsForReporting (courseId, filter) {
    return AesirApi.postToAesir(`report/courses/details/${courseId}`, getReportRequestData(filter))
}

export async function LoadReportingConfiguration () {
    return AesirApi.loadFromAesir('report/utility/configuration')
}

export async function DownloadMembersReportingExcel (filter) {
    return AesirApi.postToAesir(`report/members/excel`, getReportRequestData(filter), true,
        {
            responseType: 'blob'
        })
        .then((response) => {
            const file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
            FileSaver.saveAs(file, 'report.xlsx')
        })
        .catch((error) => {
            console.log('error', error)
        })
}

export async function DownloadCoursesReportingExcel (filter) {
    return AesirApi.postToAesir(`report/courses/excel`, getReportRequestData(filter), true,
        {
            responseType: 'blob'
        })
        .then((response) => {
            const file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
            FileSaver.saveAs(file, 'report.xlsx')
        })
        .catch((error) => {
            console.log('error', error)
        })
}

export async function LoadChatSessions () {
    return getChatClient().LoadChatSessions()
}

export async function LoadSingleChatHistory (chatId) {
    return getChatClient().LoadSingleChatHistory(chatId)
}

export async function LoadLspSupportedFormats () {
    return AesirApi.loadFromAesirWithoutMember(`lsp/supported-formats`)
}

export async function LoadLspSupportedLanguages () {
    return AesirApi.loadFromAesirWithoutMember(`lsp/supported-languages`)
}

export async function DownloadLspFile (courseId, courseTitle, language, format) {
    try {
        const response = await AesirApi.loadFromAesir(`courses/${courseId}/download-lsp?language=${language}&version=${format}`, true, {
            Accept: 'application/json, text/plain,application/zip',
            responseType: 'blob'
        })

        const file = new Blob([response], { type: 'application/zip' })
        store.dispatch('Courses/setLspExportErrors', [])
        FileSaver.saveAs(file, courseTitle + '.zip')
    } catch (error) {
        if (
            error.request.responseType === 'blob' &&
                error.response.data instanceof Blob &&
                error.response.data.type &&
                error.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.onload = () => {
                    error.response.data = JSON.parse(reader.result)
                    if (error.response.data.errors) {
                        store.dispatch('Courses/setLspExportErrors', error.response.data.errors)
                    } else {
                        store.dispatch('Courses/setLspExportErrors', [{ field: 'general', message: 'An error occurred while exporting the file.' }])
                    }
                    resolve(Promise.reject(error))
                }

                reader.onerror = () => {
                    reject(error)
                }

                reader.readAsText(error.response.data)
            })
        }

        return Promise.reject(error)
    }
}
